import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageCrew } from '../voyageCrew-sidecar'
import { voyageTilemap } from '../voyageTilemap-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'
import { voyageMessageWeaponCommand } from './voyageMessageWeaponCommand-sidecar'
import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageWeaponCommand {
  command: EWeaponCommand
  systemId: number
  crewId: number
}

export enum EWeaponCommand {
  Load = 0,
  Fire = 1,
}

export const voyageMessageId = EVoyageMessage.WeaponCommand

export function write(m: IMessageWriter, d: IMessageWeaponCommand) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write8(m, d.command)
  messageWriter.write32(m, d.systemId)
  messageWriter.write32(m, d.crewId)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageWeaponCommand = {
    command: messageWriter.read8(m),
    systemId: messageWriter.read32(m),
    crewId: messageWriter.read32(m),
  }
  return d
}

export function test() {
  let ex: IMessageWeaponCommand = {
    command: EWeaponCommand.Fire,
    systemId: 1234,
    crewId: 5324,
  }
  messageWriter.test('weapon-command', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)

  let t = voyageTilemap.getSystemById(msg.systemId)
  assert.notNil(t)
  let cr = voyageCrew.findById(msg.crewId)
  assert.notNil(cr)
  let sys = t.system
  assert.notNil(sys)
  if (sys.data.networkProcessWeaponCommand) {
    sys.data.networkProcessWeaponCommand(msg, cr, t, sys)
  }

  // if (msg.command === EWeaponCommand.Load) {
  // }
  // if (msg.command === EWeaponCommand.Fire) {
  // }
}

export function sendMessageAndImmediatelyExecute(msg: IMessageWeaponCommand) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
